import { useState } from 'react'

import { surveysAPI } from '../api/services/surveys'
import { Survey } from '../api/services/surveys/types.ts'

export const useSurveys = () => {
  const [surveys, setSurveys] = useState<Survey[] | null>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  const fetchSurveys = async () => {
    try {
      setLoading(true)
      const response = await surveysAPI.getSurveys()
      if (response.status === 200) {
        const updated: (Survey & { checked: boolean })[] = response.data?.map((item)=> ({
          ...item,
          checked: false,
        })) ?? []
        setSurveys(updated)
      }
      if (response.status !== 200) setError(response.error)

      return response
    } catch {
    } finally {
      setLoading(false)
    }
  }

  return {
    surveys,
    fetchSurveys,
    loading,
    error
  }
}
